/* eslint-disable import/prefer-default-export */
// @flow
import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { TemplateResponse } from 'types/templates'

type TemplateParams = {
  page?: number,
  pageSize?: number,
  search?: string,
}

export async function getTemplates(
  { page = 1, pageSize = 10, search = '' }: TemplateParams = {},
  requestParams: { signal?: AbortSignal } = {}
): Promise<TemplateResponse> {
  return await makeGetRequest(
    ApiBase + `/templates?page=${page}&page_size=${pageSize}&search=${search}`,
    requestParams
  )
}
